import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import {Factory as FilterFactory} from './components/mobile/filter/factory';
import {Factory as PlayersListFactory} from './components/mobile/players-list/factory';
import Dashboard from './components/mobile/dashboard';
import $ from 'jquery';

class UsedPlayersList extends Component {
    componentDidMount() {
        $('body').scrollTop(0);
    }

    render() {
        const {sportConfig} = this.props;

        const Filter = FilterFactory.getComponent(sportConfig);
        const PlayersList = PlayersListFactory.getComponent(sportConfig);

        return (
            <div className="tab-content players-content show">
                <Dashboard />
                <Filter sport={sportConfig.getSport()} />
                <PlayersList />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

const UsedPlayersListComponent = connect(mapStatesToProps)(UsedPlayersList);

export {UsedPlayersListComponent};
